import angular from 'angular';

module.exports = angular.module('common.models.humanUnavailability', [
  require('angular-resource')
])
  .factory('HumanUnavailability', function(odResource) {
    return odResource('/api/v1/humans/:human_id/unavailabilities/:id', {
      human_id: '@human_id',
      id: '@id'
    },
    {
      save: {
        method: 'POST',
        toast: {
          success: 'Created availability exception',
          error: 'Could not create availability exception',
        }
      },
      delete: {
        method: 'DELETE',
        toast: {
          success: 'Removed availablility exception',
          error: 'Coule not remove availability exception',
        }
      }

    });
  }).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/models/human_unavailability.js
 **/